
import { Component, Vue } from 'vue-property-decorator';
import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
import { InputDialogController, InputDialogOptions, IDialog, IDialogMessage } from '@/components/dialogs/DialogProps';

@Component({
    name: 'alertDialog',
    mixins: [DialogMixin],
})
export default class InputDialog extends Vue implements InputDialogController {
    private loading?: {
        message?: string;
    } = null!;

    get dialog(): IDialog {
        return this as any;
    }

    get ops(): InputDialogOptions {
        return this.dialog.options as InputDialogOptions;
    }

    private attemptClose = false;

    private backdropClose: true | undefined;

    input = '';

    mounted(): void {
        if (this.ops.getController) {
            this.ops.getController(this);
        }
        this.input = this.ops.defaultValue || '';
        this.backdropClose = this.ops.backdropClose;
    }

    getInput(): string {
        return this.input;
    }

    showLoading(message?: string): void {
        this.loading = {
            message: message,
        };
        this.attemptClose = false;
        this.dialog.options.backdropClose = undefined;
    }
    hideLoading(): void {
        this.loading = undefined;
        this.attemptClose = false;
        this.dialog.options.backdropClose = this.backdropClose;
    }

    updateContent(message?: IDialogMessage): void {
        this.ops.message = message;
        this.attemptClose = false;
    }

    dismiss(): void {
        this.dialog.cancel();
    }

    private onBtnNo(): void {
        this.dialog.cancel();
    }

    private onBtnOk(): void {
        if (this.ops.ok) {
            this.attemptClose = true;
            this.ops.ok(this);
            if (this.attemptClose) {
                this.dialog.proceed(null);
            }
        } else {
            this.dialog.proceed(null);
        }
    }
}
